import { render, staticRenderFns } from "./TencentyunCosUploadMultiImgOrPdf.vue?vue&type=template&id=843f23d6&scoped=true&"
import script from "./TencentyunCosUploadMultiImgOrPdf.vue?vue&type=script&lang=js&"
export * from "./TencentyunCosUploadMultiImgOrPdf.vue?vue&type=script&lang=js&"
import style0 from "./TencentyunCosUploadMultiImgOrPdf.vue?vue&type=style&index=0&id=843f23d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843f23d6",
  null
  
)

export default component.exports